var React = require('react');

function Telefonbas (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M74.7 93.2c-7-11.4-2.8-17.7 2.2-20.5 3.3-1.8 7 .2 8.9 3.4l1.9 3a7 7 0 0 1-1.2 8.8c-1.7 1.5-2.6 3.8-1.7 5.8a40.4 40.4 0 0 0 14.5 14.1c2.3 1.5 5.4 1 7.2-1.1a6 6 0 0 1 7.5-1.2l1.9 1.1c3.5 2.1 5.3 6.7 2.7 9.8-6.2 7.5-16.2 4.9-24.8-1.4-11.2-9-12.6-11-19.1-21.8Z","stroke":"#000","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("circle",{"cx":"96","cy":"96","r":"47","stroke":"#000","strokeWidth":"4","key":1}),React.createElement("circle",{"cx":"96","cy":"96","r":"60","stroke":"#000","strokeWidth":"4","key":2})]);
}

Telefonbas.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Telefonbas;

Telefonbas.default = Telefonbas;
